import { NotificationsSettings } from '@features/components/NotificationTabs';

export const NotificationsSettingsPage = () => {
  return (
    <div className="flex flex-col gap-8 w-full">
      <NotificationsSettings />
    </div>
  );
};
